import { getCustomFieldModel, FieldModel } from '../FormObserver';
import ValidationModel from '../FormObserver/ValidationModel';
import { StandardFieldConfig } from 'App/resources/AllIWant';
import CustomField from 'App/resources/Model/CustomField';

type Args = {
	requiredFields: { [key: string]: boolean };
	standardFields: { [key: string]: StandardFieldConfig };
	hasNewFields: boolean;
	customFields: CustomField[];
};

/**
 * Validation model for the React edit/create-contact modal. Mirrors the field
 * rules enforced by the legacy Angular modal (required flags come from the
 * org's standard-field config) while staying declarative.
 */
const getEditContactValidationModel = ({ requiredFields, standardFields, hasNewFields, customFields }: Args) => {
	const model: { [field: string]: ValidationModel } = {
		firstName: FieldModel.string('default.firstName').required(requiredFields.Name).max(100),
		lastName: FieldModel.string('default.lastName').required(requiredFields.Name).max(100),
		title: FieldModel.string('default.title').required(requiredFields.Title).max(100),
		email: FieldModel.email('default.email').required(requiredFields.Email).max(100),
		phone: FieldModel.string('default.phone').required(requiredFields.Phone).max(100),
		phoneCountryCode: FieldModel.string('default.phoneCountryCode'),
		cellPhone: FieldModel.string('default.cellPhone').required(requiredFields.Cellphone).max(100),
		cellPhoneCountryCode: FieldModel.string('default.cellPhoneCountryCode'),
		notes: FieldModel.string('default.notes').required(requiredFields.Notes).max(65_535),
		client: FieldModel.keyedObject('default.account', 'id').default(null),
		journeyStep: FieldModel.string('default.journeyStep'),
		categories: FieldModel.listOf('default.categories', FieldModel.keyedObject('', 'id')),
		projects: FieldModel.listOf('default.campaigns', FieldModel.keyedObject('', 'id'))
	};

	if (hasNewFields) {
		if (standardFields.Salutation?.active) {
			model.salutation = FieldModel.string(standardFields.Salutation.nameTag).required(requiredFields.Salutation);
		}
		if (standardFields.TitleCategory?.active) {
			model.titleCategory = FieldModel.string(standardFields.TitleCategory.nameTag).required(
				requiredFields.TitleCategory
			);
		}
		Object.values(standardFields)
			.filter(field => field.group === 'social' && field.active)
			.forEach(field => {
				model[field.field] = FieldModel.string(field.nameTag).required(field.required).max(255);
			});
	}

	if (customFields.length) {
		model.custom = getCustomFieldModel(customFields);
	}

	return model;
};

export default getEditContactValidationModel;
